import * as cheetahGrid from "cheetah-grid";
import { getLDCSystem } from "../../global";

TableKPIConfig

let styleCollumn = { 
  font: '12px sans-serif',
  textAlign: 'left'
}


let styleBlockdCollumn = { ...styleCollumn, color: '#00000095'
}


let inputEditor = new cheetahGrid.columns.action.InlineInputEditor();

inputEditor.disabled = (record) => {
  if(record != null || record != undefined){
    let result = record.signal == '';

    return result;
  } else {
    return false;
  }
};

let inputEditorTarget = new cheetahGrid.columns.action.InlineInputEditor();

inputEditorTarget.disabled = (record) => {
  if(record != null || record != undefined){
    let result = record.signal == '';
    result = result || !record.isNumber;

    return result;
  } else {
    return false;
  }
};

let inputAnalysisEditor = new cheetahGrid.columns.action.InlineInputEditor();

inputAnalysisEditor.disabled = (record) => {
  
  if(record != null || record != undefined){
    return (
        (record.type == 'analitico' 
          || record.type == "sazonal" 
          || record.type == "sazonalacumturno" 
          || record.type == "sazonalacumdia"
        ) && record.signal != ''  ? false : true );
  } else {
    return false;
  }
};

let signalMenuEditor = new cheetahGrid.columns.action.InlineMenuEditor({
  options: [
    { value: '', label: 'Grupo' },
    { value: '=', label: 'LIE e LSE' },
    { value: '<', label: 'LIE' },
    { value: '>', label: 'LSE' }
  ]
});

// signalMenuEditor.disabled = (record) => {
//   if(record != null || record != undefined){
//     return (record.signal == '');
//   } else {
//     return false;
//   }
// };

let signalOption = new cheetahGrid.columns.type.MenuColumn({
  options: [
    { value: '', label: 'Grupo' },
    { value: '=', label: 'LIE e LSE' },
    { value: '<', label: 'LIE' },
    { value: '>', label: 'LSE' }
  ]
});

let typeOption = new cheetahGrid.columns.type.MenuColumn({
  options: [
    { value: 'analitico', label: 'Analítico' },
    { value: 'diario', label: 'Diário' },
    { value: 'online', label: 'Online' },
    { value: 'sazonal', label: 'Saz. Cons. Dia'},
    { value: 'sazonalacumdia', label: 'Saz. Acum. Dia'},
    { value: 'sazonalacumturno', label: 'Saz. Acum. Turno'}
  ]
});

let typeAction = new cheetahGrid.columns.action.InlineMenuEditor({
  options: [
    { value: 'analitico', label: 'Analítico' },
    { value: 'diario', label: 'Diário' },
    { value: 'online', label: 'Online' },
    { value: 'sazonal', label: 'Saz. Cons. Dia'},
    { value: 'sazonalacumdia', label: 'Saz. Acum. Dia'},
    { value: 'sazonalacumturno', label: 'Saz. Acum. Turno'}
  ]
});

let closingTypeOptionCalculation = new cheetahGrid.columns.type.MenuColumn({
  options:[
    {value: 'media', label: 'Média'},
    {value: 'lastvalueshift', label: 'Últ.Valor Turno'}
  ]
});

let closingTypeActionCalculation = new cheetahGrid.columns.action.InlineMenuEditor({
  options:[
    {value: 'media', label: 'Média'},
    {value: 'lastvalueshift', label: 'Últ.Valor Turno'}
  ]
});

typeAction.disabled = (record) => {  
  if(record && record.indicatorPlan){

    let cleanNotSazonal = (record.type == "sazonal" || record.type == "sazonalacumturno" || record.type == "sazonalacumdia") && (record.indicatorPlan.split("-").length == 2);
    let cleanNotAnalitico = record.type == "analitico" && record.indicatorPlan.split("|").length == 4;

    if(!(cleanNotSazonal || cleanNotAnalitico)){
      record.indicatorPlan = "";
    }
    return (record.signal == '');

  }else if(record && record.indicatorPlanBI){

    let cleanNotSazonal = record.type == "sazonal" && record.indicatorPlanBI.split("-").length == 2;

    if(cleanNotSazonal){
      record.indicatorPlanBI = "";
    }
    return (record.signal == '');

  }
   else {
    return false;
  }
};

const TableKPIConfig = {
  Header: [
    { 
      field: 'id', 
      caption: 'Id', 
      width: "2.245172878%", 
      minWidth: "30px",
      style: styleBlockdCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort' 
    },
    { 
      field: 'indicator', 
      caption: 'Indicador', 
      width: "18.71%", 
      minWidth: "250px", 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort' 
    },
    { 
      field: 'signal', 
      caption: 'Operador', 
      width: "6.73%", 
      minWidth: "90px", 
      columnType: signalOption, 
      action: signalMenuEditor, 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort' 
    },
    { 
      field: 'operationalRange', 
      caption: 'Range Operação (%)', 
      width: "10.78%",
      minWidth: "140px",  
      action: inputEditor, 
      style: styleCollumn,  
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if(isNaN(parseFloat(rec.operationalRange)))
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    { 
      field: 'criticalRange', 
      caption: 'Range Crítico (%)', 
      width: "9.35%",
      minWidth: "125px", 
      action: inputEditor, 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if(isNaN(parseFloat(rec.criticalRange)))
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    { 
      field: 'reabilityThreshold', 
      caption: 'Meta Aderência (%)', 
      width: "9.35%", 
      minWidth: "125px", 
      action:'input', 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if(isNaN(parseFloat(rec.reabilityThreshold)))
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    { 
      field: 'criticReabilityThreshold', 
      caption: 'Limite Aderência (%)', 
      width: "9.72%",
      minWidth: "130px",
      action:'input', 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if(isNaN(parseFloat(rec.criticReabilityThreshold)))
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    //Campo TARGET configurado no back, esta temporáriamente oculto 
    { 
      field: 'target', 
      caption: 'Referência', 
      width: "5.98%",
      minWidth: "80px",
      action: inputEditorTarget, 
      style: styleCollumn,
      headerStyle: styleCollumn, 
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if((isNaN(parseFloat(rec.target)) && rec.target != null) && rec.target != '')
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    { 
      field: 'delay', 
      caption: (getLDCSystem() == 'true' || getLDCSystem() == true) ? 'Atraso (min)': 'Atraso (h)', 
      width: "5.6%",
      minWidth: "75px",  
      action: inputAnalysisEditor, 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if((isNaN(parseFloat(rec.delay)) && rec.delay != null) && rec.delay != ''){
          return 'Por favor, digite apenas número.'
        }
        return null;
      }
    },
    { 
      field: 'analysis', 
      caption: 'Análises', 
      width: "4.86%",
      minWidth: "65px",   
      action: inputAnalysisEditor, 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if((isNaN(parseFloat(rec.analysis)) && rec.analysis != null) && rec.analysis != '')
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    { 
      field: 'weigth', 
      caption: 'Peso', 
      width: "3.74%",
      minWidth: "50px",   
      action: inputEditor, 
      style: styleCollumn,
      headerStyle: styleCollumn, 
      headerType: 'sort', 
      headerAction: 'sort',
      message(rec){
        if(isNaN(parseFloat(rec.weigth)))
          return 'Por favor, digite apenas número.'
        return null;
      }
    },
    { 
      field: 'type', 
      caption: 'Tipo do Cálculo', 
      width: "11%", 
      minWidth: "80px", 
      columnType: typeOption, 
      action: typeAction, 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort' 
    },
    { 
      field: 'indicatorPlan', 
      caption: 'Variável', 
      width: "5.23%", 
      minWidth: "70px", 
      style: styleCollumn,
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      action: new cheetahGrid.columns.action.ButtonAction({
        action(rec) {
          if(rec.type == "sazonal" || rec.type == "sazonalacumturno" || rec.type == "sazonalacumdia" ){
              TableKPIConfig.gridKpiModal(rec, 'indicatorPlan')
          } 
          if(rec.type == "analitico"){
            TableKPIConfig.showModalGreatness(rec, 'indicatorPlan')
          }
        },
      }),      
    },
    { 
      field: 'indicatorPlanBI', 
      caption: 'BI', 
      width: "5.23%", 
      minWidth: "70px", 
      style: styleCollumn,
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort',
      action: new cheetahGrid.columns.action.ButtonAction({
        action(rec) {
          if(rec.type == "analitico" || rec.type == "online" || rec.type == "diario"){
            TableKPIConfig.gridKpiModal(rec, 'indicatorPlanBI')
          } 
        },
      }),      
    },
    { 
      field: 'closingTypeCalculation', 
      caption: 'Tipo Calc. Fechamento', 
      width: "9.80%", 
      minWidth: "80px", 
      columnType: closingTypeOptionCalculation, 
      action: closingTypeActionCalculation, 
      style: styleCollumn, 
      headerStyle: styleCollumn,
      headerType: 'sort', 
      headerAction: 'sort' 
    },
  ],
  gridKpiModal: () => {
    
  },
  showModalGreatness: () =>{

  }
}

export default TableKPIConfig;